import { domain } from "../utils/APIRoutes";

export const endpoint = {
  member_login: `${domain}/api/v17/member-login`,
  member_register: `${domain}/api/v17/member-registeration`,
  member_details: `${domain}/api/v17/member-profile-details`,
  home_page_news: `${domain}/api/v17/get-news-and-updates`,
  my_trades: `${domain}/api/v17/get-trade-history`,
  profile_detail: `${domain}/api/v17/member-profile-details`,
  update_profile: `${domain}/api/v17/change-member-profile-by-user`,
  update_nominee_details: `${domain}/api/v17/update-nominee-details`,
  agency_details: `${domain}/api/v17/get-agency-details`,
  place_trade_order: `${domain}/api/v17/place-trade-order`,
  get_topup_qr: `${domain}/api/v17/get-topup-qr`,
  member_self_topup: `${domain}/api/v17/member-self-topup`,
  get_wallet_transactions: `${domain}/api/v17/member-wallet-transactions`,
  member_claimed_pending_transaction: `${domain}/api/v17/member-claim-pending-transaction`,
  member_fund_transfer: `${domain}/api/v17/member-fund-transfer-p2p`,
  get_spon_name: `${domain}/api/v17/member-name-by-cust-id`,
  get_report_details: `${domain}/api/v17/get-report-details`,
  member_payout: `${domain}/api/v17/member-payout`,
  member_payout_report: `${domain}/api/v17/member-payout-report`,
  send_otp: `${domain}/api/v17/send-otp`,
  verify_otp: `${domain}/api/v17/verify-otp`,
  get_package_details: `${domain}/api/v17/get-package-details`,
  get_bot_history: `${domain}/api/v17/get-bot-package-details`,
  get_bot_trades: `${domain}/api/v17/get-trades`,
  get_downline_team: `${domain}/api/v17/get-downline-team`,
  user_message: `${domain}/api/v17/user-message`,
  get_user_messages: `${domain}/api/v17/get-user-messages`,
  change_bot_plan: `${domain}/api/v17/change-auto-bot`,
  check_bot_subscription: `${domain}/api/v17/check-is-already-bot-bought`,
};
